import qs from 'qs'

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$qs', { value: qs })
  },
}
